
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    CircularProgress,
} from '@mui/material';

export default function CreateWhiteboard({ open, onClose, onCreate, isLoading, editingBoard }) {
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    // Reset when dialog opens
    useEffect(() => {
        if (open) {
            setName(editingBoard?.name ?? '');
            setError('');
        }
    }, [open]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const whiteboardName = name.trim();
        if (!whiteboardName) {
            setError('Please enter a name.');
            return;
        }
        onCreate(whiteboardName);
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="sm"
            aria-labelledby="create-whiteboard-title"
        >
            <form onSubmit={handleSubmit}>
                <DialogTitle id="create-whiteboard-title">
                    {`${editingBoard?.id ? 'Edit' : 'Create'} Whiteboard`}
                </DialogTitle>
                <DialogContent sx={{ pt: '20px !important' }}>
                    <TextField
                        autoFocus
                        fullWidth
                        label="Whiteboard Name"
                        placeholder="Untitled Whiteboard"
                        value={name}
                        onChange={(e) => {
                            setName(e.target.value);
                            if (error) setError('');
                        }}
                        error={Boolean(error)}
                        helperText={error || undefined}
                        inputProps={{ maxLength: 100 }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button
                        onClick={onClose}
                        disabled={isLoading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        variant="contained"
                        disabled={!name.trim() || isLoading}
                    >
                        {
                            isLoading ?
                                <CircularProgress size={20} color='inherit' /> :
                                editingBoard?.id ? 'Update' : 'Create'
                        }
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
}

CreateWhiteboard.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func,
    onCreate: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    editingBoard: PropTypes.object
};
